import { put } from "redux-saga/effects";
import AppsmithConsole from "utils/AppsmithConsole";
import { ActionValidationError } from "sagas/ActionExecution/errorUtils";
import { getType, Types } from "utils/TypeHelpers";
import type {
  TCloseOverlayDescription,
} from "workers/Evaluation/fns/overlayFns";

export function* closeOverlaySaga(action: TCloseOverlayDescription) {
  const { overlayName } = action.payload;
  if (typeof overlayName !== "string") {
    throw new ActionValidationError(
      "CLOSE_OVERLAY",
      "name",
      Types.STRING,
      getType(overlayName),
    );
  }
  console.log("overlay action", action)
  yield put(action);
  AppsmithConsole.info({
    text: `closeOverlay(${overlayName}) was triggered`,
  });
}